namespace RioERP.Shipping {
    export interface ShippingProvidersForm {
        ShippingProviderName: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        BankAccountNo: Serenity.StringEditor;
        BankIfscCode: Serenity.StringEditor;
        TrackingUrl: Serenity.StringEditor;
        EApiStatus: Serenity.EnumEditor;
        Gstin: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        GstCertificate: Serenity.StringEditor;
        Secret: Serenity.StringEditor;
        VendorId: Serenity.LookupEditor;
        EShippingProviderType: Serenity.EnumEditor;
        IsDefault: Serenity.BooleanEditor;
    }

    export class ShippingProvidersForm extends Serenity.PrefixedContext {
        static formKey = 'Shipping.ShippingProviders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShippingProvidersForm.init)  {
                ShippingProvidersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ShippingProvidersForm, [
                    'ShippingProviderName', w0,
                    'Description', w0,
                    'BankName', w0,
                    'BankAccountNo', w0,
                    'BankIfscCode', w0,
                    'TrackingUrl', w0,
                    'EApiStatus', w1,
                    'Gstin', w0,
                    'Pan', w0,
                    'GstCertificate', w0,
                    'Secret', w0,
                    'VendorId', w2,
                    'EShippingProviderType', w1,
                    'IsDefault', w3
                ]);
            }
        }
    }
}
